export const enrichInstalledAppData = _ref => {
  let {
    appId,
    tenantId,
    installedApp
  } = _ref;
  return {
    appId,
    tenantId,
    version: installedApp.version || undefined,
    requiredActions: installedApp.requiredActions,
    instanceId: installedApp.instanceId || undefined
  };
};
//# sourceMappingURL=enrich-installed-app-data.js.map